module.exports = __webpack_public_path__ + "img/tschley2.431ddea3.jpg";